import qs from 'query-string';
import { Redirect, useLocation } from 'react-router-dom';

function ForwardRedirect() {
  const location = useLocation();
  const { route, ...restQueryParams } = qs.parse(location.search);

  return (
    <Redirect
      to={{
        pathname: route as string,
        state: { queryParams: restQueryParams },
      }}
    />
  );
}

export default ForwardRedirect;
